module.exports = __webpack_public_path__ + "img/what-drac-does-not-say.995fb2d0.jpg";